import { render, staticRenderFns } from "./SocialSettingsWidget.vue?vue&type=template&id=361294fb&scoped=true"
import script from "./SocialSettingsWidget.vue?vue&type=script&lang=js"
export * from "./SocialSettingsWidget.vue?vue&type=script&lang=js"
import style0 from "./SocialSettingsWidget.vue?vue&type=style&index=0&id=361294fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361294fb",
  null
  
)

export default component.exports